import { useContext, useState } from 'react';
import useSelectedFilterSet from '../../../../hooks/useSelectedFilterSet';
import { SAVED_FILTER_SET_TYPES } from '@linearb/linjs-common';

const useListType = Context => {
  const selectedFilterSet = useSelectedFilterSet(Context);
  const {
    state: { filterSets }
  } = useContext(Context);

  const getDefaultType = () => {
    const existedTypes = [
      ...new Set(Object.values(filterSets).map(filterSet => filterSet.type))
    ];
    const typePriority = [
      SAVED_FILTER_SET_TYPES.PROJECT,
      SAVED_FILTER_SET_TYPES.FILTER_SET
    ];
    const defaultType =
      typePriority.find(type => existedTypes.includes(type)) ||
      SAVED_FILTER_SET_TYPES.PROJECT;

    return defaultType;
  };

  const [type, setType] = useState(selectedFilterSet?.type || getDefaultType());

  return [type, setType];
};

export default useListType;
